// Status do lote de Pagamento de Taxa SP (espelha o StatusLoteTaxa do backend).
export enum StatusLoteTaxa {
  PENDENTE = 0,
  FINALIZADO = 1,
}

export const StatusLoteTaxaLabel: Record<number, string> = {
  [StatusLoteTaxa.PENDENTE]: "Pendente",
  [StatusLoteTaxa.FINALIZADO]: "Finalizado",
};
